import type { ApiOrganizationMember } from "~/server/api/organizations/[organizationId]/members/index.get";
import type { ApiInviteMemberRequest } from "~/server/api/organizations/[organizationId]/members/index.post";

export function useApiOrganizationMembers() {
  const { organizationId } = useOrganizationId();
  return useFetch<ApiOrganizationMember[]>(
    () => `/api/organizations/${organizationId.value}/members`
  );
}

export async function inviteMember(email: string): Promise<{ success: boolean; message: string }> {
  const { organizationId } = useOrganizationId();
  return $fetch<{ success: boolean; message: string }>(`/api/organizations/${organizationId.value}/members`, {
    method: "POST",
    body: { email } as ApiInviteMemberRequest
  });
}

export async function updateMemberRole(userId: string, role: 'ADMIN' | 'MEMBER'): Promise<ApiOrganizationMember> {
  const { organizationId } = useOrganizationId();
  return $fetch<ApiOrganizationMember>(`/api/organizations/${organizationId.value}/members/${userId}`, {
    method: "PUT",
    body: { role }
  });
}

export async function removeMember(userId: string): Promise<{ success: boolean; message: string }> {
  const { organizationId } = useOrganizationId();
  return $fetch<{ success: boolean; message: string }>(`/api/organizations/${organizationId.value}/members/${userId}`, {
    method: "DELETE"
  });
}
